import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    /*
    asdf({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'url/', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    */
   facturacionExcel_downloadModel() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'facturacion-excel/download-model')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    facturacionExcel_uploadExcel({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'facturacion-excel/upload-excel', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};